import React from "react";
import { Button } from 'reactstrap';
import "./index.scss";
const AppLogo = ({ className = '', }) => {

	return (
		<>
			<div color="link" className={`app-logo d-inline-flex flex-column text-end p-0 ${className}`}>
				<img className="img-fluid" src={require("../../../assets/img/Main_Logo.png")} alt="App Logo" />
				<div className="link-logo d-flex align-items-end">
					by{/* by <Button color="link" > */}
					<a target="_blank" rel="noopener,noreferrer" href="https://gettrained.ai/" className="link">
						<img className="img-fluid" src={require("../../../assets/img/app-logo.png")} alt="App Logo" />
					</a>
					{/* </Button> */}
				</div>
			</div>
		</>
	);
}

export default AppLogo;